import { createClient } from "@supabase/supabase-js";
import { ENV } from "@/config";

if (!ENV.supabaseUrl || !ENV.supabasePublishableKey) {
  throw new Error("Missing VITE_SUPABASE_URL or VITE_SUPABASE_PUBLISHABLE_KEY (see apps/connect/.env.example).");
}

export const supabase = createClient(ENV.supabaseUrl, ENV.supabasePublishableKey, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});
